<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">アイコンファイル適用期間指定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>アイコン情報</h1>
          <div class="column-list">
            <label class="list-input-title">アイコンコード</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.iconCode" [style.width.rem]="3" id="txt_IconCode" #txt_IconCode readonly>
            </div>
            <label class="list-input-title">アイコン名</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.iconName" [style.width.rem]="22" readonly>
            </div>
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.iconGroup" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">アイコン区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.iconDiv" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">配置区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.arrangeDiv" [style.width.px]="200" readonly>
            </div>
            <label class="list-input-title">アイコン説明</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.iconExplain" [style.width.px]="320" readonly>
            </div>
            <label class="list-input-title">出力区分</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw1510Model.outputDiv" [style.width.px]="450" readonly>
            </div>
          </div>
        </div>

        <div>
          <h1>ファイル情報</h1>
          <div class="column-list">
            <label class="list-input-title">使用開始受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
                [catalogIDField]="lbl_StartDelivCatalogId" [disabled]="!kymw1510Model.startOrderCodeEnabled"
                [(ngModel)]="kymw1510Model.startOrderCode" [tabindex]="0" [required]="true" class="deliv-catalog">
              </app-order-code-text-input>
              <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                label="指定なし" [(ngModel)]="kymw1510Model.notDesignateStart" (change)="eventNotDesignateStart_CLICKHandler()"
                autofocus="true" [tabindex]="0">
              </app-checkbox-label>
            </div>
            <label class="list-input-title">使用開始配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="lbl_StartDelivCatalogId" #lbl_StartDelivCatalogId readonly/>
            </div>
            <label class="list-input-title">使用終了受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
                [catalogIDField]="lbl_EndDelivCatalogId" [disabled]="!kymw1510Model.endOrderCodeEnabled"
                [(ngModel)]="kymw1510Model.endOrderCode" [tabindex]="0" [required]="true">
              </app-order-code-text-input>
              <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                label="指定なし" [(ngModel)]="kymw1510Model.notDesignateEnd" (change)="eventNotDesignateEnd_CLICKHandler()" [tabindex]="0">
              </app-checkbox-label>
            </div>
            <label class="list-input-title">使用終了配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="lbl_EndDelivCatalogId" #lbl_EndDelivCatalogId readonly/>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_setting" class="btn-primary" (click)="eventSetting_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0" #btn_setting>設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
